import { PAYMENT_INIT_SOURCE } from '../../../constants/config';
import {
  fetchCloudpaymentsStartWidgetPayment,
  IMappers,
} from '../../../repositories/billing-accounts/v1/cloudpayments-start-widget-payment';
import { THeaders } from '../../../types/request';
import { IGetCloudPaymentsWidgetDataParams, TGetCloudPaymentsWidgetDataResult } from './types';
import { mapResponse200, mapResponse400 } from './utils';

export const getCloudPaymentsWidgetData = async (
  params: IGetCloudPaymentsWidgetDataParams,
): Promise<TGetCloudPaymentsWidgetDataResult> => {
  const { httpApi, amount } = params;

  const parameters = {
    // Список источников https://conf.cian.tech/pages/viewpage.action?pageId=1324019663
    paymentInitSource: PAYMENT_INIT_SOURCE,
    amount,
  };

  const mappers: IMappers<TGetCloudPaymentsWidgetDataResult, TGetCloudPaymentsWidgetDataResult> = {
    200: mapResponse200,
    400: mapResponse400,
  };

  const headers: THeaders = [['Content-Type', 'application/json']];

  const config = {
    requestConfig: {
      headers,
    },
  };

  try {
    const result = await fetchCloudpaymentsStartWidgetPayment({ httpApi, parameters, mappers, config });

    return result as TGetCloudPaymentsWidgetDataResult;
  } catch (_) {
    return null;
  }
};
